import { Timestamp } from "@bufbuild/protobuf";
import { useInfiniteQuery } from "@tanstack/react-query";
import { subMonths } from "date-fns";
import { TimePaginationRequest } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import type { ConnectClient } from "../../../libs/api";
import { AppError, ERROR_CODES } from "../../../libs/errors";

export const useInfiniteTransactions = (client: ConnectClient) => {
  return useInfiniteQuery({
    queryKey: ["transactions"],
    queryFn: async ({ pageParam }) => {
      const limitDate = subMonths(pageParam, 6);

      const pagination = new TimePaginationRequest({
        offset: Timestamp.fromDate(pageParam),
        limit: Timestamp.fromDate(limitDate),
      });

      const res = await client
        .getMyTransactions({ pagination })
        .catch((error) => {
          throw new AppError(
            ERROR_CODES.CONNECT_GET_MY_TRANSACTION_FAILED,
            error instanceof Error ? error.message : String(error),
            { originalError: error },
          );
        });

      return {
        transactionGroups: res.transactionGroups,
        // バックエンドからのnextOffsetがあればそれを使用、なければlimitDateを使用して無限に遡れるようにする
        nextOffset: res.pagination?.nextOffset?.toDate() ?? limitDate,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextOffset,
    staleTime: 1000 * 60 * 5, // 5分間はキャッシュを古いと判断しない
    gcTime: 1000 * 60 * 30, // 30分間キャッシュを保持
    initialPageParam: new Date(),
  });
};
